import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom'

import PropTypes from 'prop-types'

class AppLink extends Component {
  render() {
    switch (this.props.type) {
      case 'nav':
        return (
          <NavLink
            exact={true}
            className={this.props.className}
            to={this.props.to}
            onClick={() => {
              window.scrollTo(0, 0)
            }}
          >
            {this.props.children}
          </NavLink>
        )
      case 'sort':
        return (
          <NavLink
            isActive={(_, location) => {
              if (location.search && this.props.to.includes('?')) {
                const current = new URLSearchParams(location.search)
                const toQuery = this.props.to.split('?')[1]

                const toParams = new URLSearchParams(toQuery)

                if (current.get('sort') === toParams.get('sort')) {
                  return true
                }
              }

              if (!this.props.to.includes('?') && location.search === '') {
                return this.props.to === location.pathname
              }

              return false
            }}
            className={this.props.className}
            to={this.props.to}
            onClick={() => {
              window.scrollTo(0, 0)
            }}
          >
            {this.props.children}
          </NavLink>
        )
      default:
        const classes = [this.props.className];
        if (this.props.interstitial) {
          classes.push("is-trigger ism-trigger")
        }

        return (
          <Link
            className={classes.join(" ")}
            to={this.props.to}
            onClick={() => {
              window.scrollTo(0, 0)
            }}
          >
            {this.props.children}
          </Link>
        )
    }
  }
}

AppLink.propTypes = {
  to: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string
}

export default AppLink
